import { render, staticRenderFns } from "./FieldUsesTab.vue?vue&type=template&id=71313aa9"
import script from "./FieldUsesTab.vue?vue&type=script&lang=js"
export * from "./FieldUsesTab.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports